var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-root-id": 7585340776194,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 132",
    y: 183.1375931959886,
    x: 221.49688720703125,
    preserveAspectRatio: "xMinYMin",
    zoom: 1,
    "data-layer-role": "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5865 53.5799C65.5998 53.5799 64 55.1893 64 57.1719V83.5159C64 85.4986 65.5998 87.1079 67.5865 87.1079C69.5731 87.1079 71.1865 85.4986 71.1865 83.5159V57.1719C71.1865 55.1893 69.5731 53.5799 67.5865 53.5799Z",
    name: "Layer %{number}",
    zoom: 1,
    "data-layer-id": 5945564176194
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5865 44.0002C66.5998 44.0002 65.7465 44.3509 65.0531 45.0495C64.3465 45.7469 64 46.5962 64 47.5936C64 48.5909 64.3465 49.4389 65.0531 50.1376C65.7465 50.8362 66.5998 51.1855 67.5865 51.1855C68.5865 51.1855 69.44 50.8362 70.1333 50.1376C70.8267 49.4389 71.1865 48.5909 71.1865 47.5936C71.1865 46.5962 70.8267 45.7469 70.1333 45.0495C69.44 44.3509 68.5865 44.0002 67.5865 44.0002Z",
    name: "Layer %{number}",
    zoom: 1,
    "data-layer-id": 5757084576194
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 1.5C36.5 0.671573 37.1716 0 38 0H110C121.874 0 131.5 9.62588 131.5 21.5V93.5C131.5 94.3284 130.828 95 130 95C129.172 95 128.5 94.3284 128.5 93.5V21.5C128.5 11.2827 120.217 3 110 3H38C37.1716 3 36.5 2.32843 36.5 1.5Z",
    name: "Layer %{number}",
    zoom: 1,
    "data-layer-id": 668967276194
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5 130.5C98.5 131.328 97.8284 132 97 132L25 132C13.1259 132 3.5 122.374 3.5 110.5L3.50001 38.5C3.50001 37.6716 4.17158 37 5.00001 37C5.82844 37 6.50001 37.6716 6.50001 38.5L6.5 110.5C6.5 120.717 14.7827 129 25 129L97 129C97.8284 129 98.5 129.672 98.5 130.5Z",
    name: "Layer %{number}",
    zoom: 1,
    "data-layer-id": 1942562276194
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 34.5C10 37.2614 7.76142 39.5 5 39.5C2.23858 39.5 0 37.2614 0 34.5C0 31.7386 2.23858 29.5 5 29.5C7.76142 29.5 10 31.7386 10 34.5Z",
    name: "Layer %{number}",
    zoom: 1,
    "data-layer-id": 1126993976194
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135 96.5C135 99.2614 132.761 101.5 130 101.5C127.239 101.5 125 99.2614 125 96.5C125 93.7386 127.239 91.5 130 91.5C132.761 91.5 135 93.7386 135 96.5Z",
    name: "Layer %{number}",
    zoom: 1,
    "data-layer-id": 256741976194
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0b60d122236d36aa1275115c2ffba924.svg";
export { ForwardRef as ReactComponent };